<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <el-col>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.search_logistics_name"
                    placeholder="物流公司"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-select v-model="form.search_status" placeholder="启用状态">
                  <el-option value="">全部</el-option>
                  <el-option
                    v-for="item in status"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>

                <el-form-item>
                  <el-button type="primary" @click="fetchData">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
        >
          数据列表
          <el-button
            style="margin-left: auto; margin-right: -15px"
            class="icon-fresh"
            type="primary"
            @click="beforeAddLogistics"
            >新增</el-button
          >
        </div>

        <div style="margin-bottom: 0;">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="logistics_name"
              label="物流名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="contacts"
              label="联系人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="contacts_phone"
              label="联系电话"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="logistics_status"
              label="启用状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="更新人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              label="更新时间"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="editLogistics(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  style="color: red"
                  size="small"
                  @click="delLogistics(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right;padding: 25px;">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[10, 20, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <edit
      v-if="visible"
      :logistics_id="form.logistics_id"
      :logistics_name="form.logistics_name"
      :contacts="form.contacts"
      :contacts_phone="form.contacts_phone"
      :remark="form.remark"
      :status="form.status"
      @onCloseDialog="closeBox"
    ></edit>
  </div>
</template>

<script>
import Edit from "./components/edit.vue";
import HeaderTabs from "../wavepicking/components/HeaderTabs";
export default {
  components: {
    Edit,
    HeaderTabs,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      curPage: 1,
      resData: {},
      form: {
        pagesize: 50,
        logistics_id: "",
        logistics_name: "",
        contacts: "",
        contacts_phone: "",
        remark: "",
        status: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Logistics/logisticsList",
      filterFold: false,
      visible: false,
      status: [
        { key: "1", name: "启用" },
        { key: "2", name: "禁用" },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then(res => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }

      this.$http.post(this.url, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    beforeAddLogistics() {
      this.form.logistics_name = "";
      this.form.logistics_id = "";
      this.form.contacts = "";
      this.form.contacts_phone = "";
      this.form.remark = "";
      this.form.status = "";
      this.visible = true;
    },
    closeBox() {
      this.fetchData();
      this.visible = false;
    },

    editLogistics(row) {
      this.form.logistics_name = row.logistics_name;
      this.form.logistics_id = row.logistics_id;
      this.form.contacts = row.contacts;
      this.form.contacts_phone = row.contacts_phone;
      this.form.remark = row.remark;
      this.form.status = row.status;
      this.visible = true;
    },
    delLogistics(row) {
      this.$confirm(`是否确认删除该物流公司?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.form.logistics_id = row.logistics_id;
        this.$http.post("/erp/Logistics/delLogistics", this.form).then(res => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.visible = false;
            this.form.logistics_id = "";
            this.fetchData();
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/logistics/logisticsList.vue